/** Shared chart styling for Bandwidth dashboard (bar colors). */

import { bandwidthVerticalBarPalette } from './bandwidthChartTheme';

export interface TimeByGroupBarRow {
  label: string;
  hours: number;
  /** When set (from dashboard API), bar drill does not rely on label → id lookup. */
  groupId?: string;
}

/** Same cycle as Dates/Users vertical bars — keeps scatter & group bars consistent. */
export function barColorsForIndex(i: number): string {
  return bandwidthVerticalBarPalette(i);
}

/** Weekday bars (Mon→Sun) — same family as `bandwidthChartTheme` vertical bars. */
export const WEEKDAY_BAR_COLORS = [
  'rgba(47, 85, 151, 0.92)',
  'rgba(68, 114, 196, 0.9)',
  'rgba(59, 130, 246, 0.88)',
  'rgba(99, 102, 241, 0.86)',
  'rgba(129, 140, 248, 0.84)',
  'rgba(139, 92, 246, 0.82)',
  'rgba(148, 163, 184, 0.82)',
] as const;
